import VideoVipTemplate from "@/components/templates/VideoVipTemplate";

export default function VideoVipLanding() {
  return <VideoVipTemplate />;
}
